import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IService } from "../serviceModel";

export const getAllService = createAsyncThunk(
  "Service/FindAllService",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindAllService`,
        {
          ServiceName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createService = createAsyncThunk(
  "Service/InsertService",
  async (ServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/InsertService`,
        ServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateService = createAsyncThunk(
  "Service/UpdateService",
  async (ServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/UpdateService`,
        ServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteService = createAsyncThunk(
  "Service/DeleteService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/DeleteService`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getServiceByID = createAsyncThunk(
  "Service/FindByIDService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/FindByIDService`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PageName: result.PageName,
        ServiceName: result.ServiceName,
        Description: result.Description,
        Charges: result.Charges,
        OrderNo: result.OrderNo,
        IsActive: result.IsActive ? 1 : 2,
      } as IService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveService = createAsyncThunk(
  "Service/FindAllActiveService",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Service/FindAllActiveService`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Servicees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveService = createAsyncThunk(
  "Service/ActiveInActiveService",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Service/ActiveInActiveService`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
